import { Account, loadAccounts } from '../../modules/accounts';
import { IStoreState, ThunkDispatch } from "../../modules";
import { IconDefinition, faCoins, faCreditCard, faSeedling } from '@fortawesome/free-solid-svg-icons';
import React, { Component, Fragment } from "react";
import { Theme, WithStyles, createStyles, withStyles } from '@material-ui/core/styles';

import { CircularProgress } from "@material-ui/core";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

const styles = (theme: Theme) => createStyles({
  root: {
    height: '100%',
  },
  accountTypeGroup: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
  accountTypeHeader: {
    marginBottom: theme.spacing(2),
    color: '#666',
  },
  accountTypeIcon: {
    marginRight: theme.spacing(2),
  },
  accountName: {
    padding: `${theme.spacing(2)}px 0`,
    border: 0,
  },
  accountBalance: {
    padding: `${theme.spacing(2)}px 0 !important`,
    border: 0,
    textAlign: 'right',
  },
  accountButton: {
    padding: `${theme.spacing(2)}px 0 !important`,
    border: 0,
    textAlign: 'right',
  },
  loading: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  progress: {
    alignSelf: 'center',
    margin: '5rem auto',
  }
});


type State = {
};

type AccountType = {
  type: string
  text: string
  icon: IconDefinition
}

class AccountsPane extends Component<Props, State> {
  componentDidMount = () => {
    document.title = "My Accounts"
  }

  render() {
    const { accounts, classes, intl } = this.props;

    const accountTypes: AccountType[] = [
      {
        type: 'deposit',
        text: 'Deposits',
        icon: faCoins,
      },
      {
        type: 'card',
        text: 'Cards',
        icon: faCreditCard,
      },
      {
        type: 'investment',
        text: 'Investments',
        icon: faSeedling,
      },
    ]

    const accountsList = accountTypes.map((accountType: AccountType, k: number) => (
      <Paper key={k} className={classes.accountTypeGroup}>
        <Typography variant="h4" className={classes.accountTypeHeader}><FontAwesomeIcon icon={accountType.icon} className={classes.accountTypeIcon} />{accountType.text}</Typography>
        <Table>
          <TableBody>
            {
              accounts.list.filter((a: Account) => a.type === accountType.type).map((account: Account, k: number) =>
                <TableRow key={k}>
                  <TableCell className={classes.accountName}><Typography variant="body1">{account.name}</Typography><Typography variant="caption">{account.id}</Typography></TableCell>
                  <TableCell valign="top" className={classes.accountBalance}>{new Intl.NumberFormat(intl.locale, { style: 'currency', currency: account.currency }).format(account.balance)}</TableCell>
                  {/*<TableCell className={classes.accountButton} padding="none" size="small"><IconButton><FontAwesomeIcon icon={faEllipsisV} size="xs" fixedWidth/></IconButton></TableCell>*/}
                </TableRow>
              )
            }
          </TableBody>
        </Table>
      </Paper>
    ))

    return (
      <div className={classes.root}>
        {accounts.loading &&
          <div className={classes.loading}>
            <CircularProgress className={classes.progress} />
          </div>
        }
        {accounts.loaded &&
          <Fragment>
            {/*<Typography variant="h4" id="pageHeader">My Accounts</Typography>*/}
            {accountsList}
          </Fragment>
        }
      </div>
    )
  }
}

const mapStateToProps = ({ accounts, auth, intl }: IStoreState) => ({
  accounts,
  auth,
  intl
})

const mapDispatchToProps = (dispatch: ThunkDispatch) =>
  bindActionCreators(
    {
      loadAccounts
    }, dispatch
  )

interface Props extends WithStyles<typeof styles>, ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps> {
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AccountsPane));